var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92.851,
    height: 72.229,
    viewBox: "0 0 92.851 72.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 92.851,
    height: 72.229,
    fill: "none",
    stroke: "#0182f0",
    strokeWidth: 1.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    transform: "translate(6.77 21.906)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.082,
    height: 23.213,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 25.582,
    height: 21.713,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_293",
    "data-name": "Path 293",
    transform: "translate(0.217 6.222)",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.553,33.092H3.666A2.915,2.915,0,0,1,.75,30.177V24.4a2.915,2.915,0,0,1,2.916-2.916H6.553Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.053201198577881 31.5924015045166 L 5.053201198577881 22.98600196838379 L 3.665781021118164 22.98600196838379 C 2.88512110710144 22.98600196838379 2.250001192092896 23.62112236022949 2.250001192092896 24.40178108215332 L 2.250001192092896 30.17662239074707 C 2.250001192092896 30.9572811126709 2.88512110710144 31.5924015045166 3.665781021118164 31.5924015045166 L 5.053201198577881 31.5924015045166 M 6.553201198577881 33.09240341186523 L 3.665781021118164 33.09240341186523 C 2.055071115493774 33.09240341186523 0.750001072883606 31.78733253479004 0.750001072883606 30.17662239074707 L 0.750001072883606 24.40178108215332 C 0.750001072883606 22.79107093811035 2.055071115493774 21.48600196838379 3.665781021118164 21.48600196838379 L 6.553201198577881 21.48600196838379 L 6.553201198577881 33.09240341186523 Z",
    stroke: "none",
    fill: "#0182f0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M49.5,22.215c3.2,0,5.8,2.165,5.8,4.836s-2.6,4.836-5.8,4.836",
    transform: "translate(14.335 6.433)",
    fill: "#faf7a3",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    transform: "translate(56.098 12.233)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.738,
    height: 42.557,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 6.238,
    height: 41.057,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_294",
    "data-name": "Path 294",
    transform: "translate(7.602 2.964)",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5,50.859l-22.246-8.7V18.941l22.246-8.7Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 46.99561309814453 48.66091918945312 L 46.99561309814453 12.43390655517578 L 27.75000190734863 19.96480369567871 L 27.75000190734863 41.13002395629883 L 46.99561309814453 48.66091918945312 M 48.49561309814453 50.85862350463867 L 26.25000190734863 42.15381240844727 L 26.25000190734863 18.94101333618164 L 48.49561309814453 10.23620319366455 L 48.49561309814453 50.85862350463867 Z",
    stroke: "none",
    fill: "#0182f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_296",
    "data-name": "Path 296",
    transform: "translate(2.172 10.131)",
    fill: "#faf7a3",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.40938377380371 40.03919982910156 L 10.47511291503906 40.03919982910156 C 9.248183250427246 40.03919982910156 8.250002861022949 39.07400131225586 8.250002861022949 37.88759994506836 L 8.250002861022949 35.73600006103516 L 25.6164493560791 35.73600006103516 L 23.40938377380371 40.03919982910156 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22.95114898681641 39.28919982910156 L 24.38887977600098 36.48600006103516 L 9.000002861022949 36.48600006103516 L 9.000002861022949 37.88759994506836 C 9.000002861022949 38.66043853759766 9.66173267364502 39.28919982910156 10.47511291503906 39.28919982910156 L 22.95114898681641 39.28919982910156 M 23.86760330200195 40.78919982910156 L 10.47511291503906 40.78919982910156 C 8.838603019714355 40.78919982910156 7.500002861022949 39.48283004760742 7.500002861022949 37.88759994506836 L 7.500002861022949 34.98600006103516 L 26.84400367736816 34.98600006103516 L 23.86760330200195 40.78919982910156 Z",
    stroke: "none",
    fill: "#0182f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_297",
    "data-name": "Path 297",
    transform: "translate(2.824 11.435)",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.807,59.8l-8.538.027L9.75,39.486H21.356Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.47121810913086 58.32067108154297 L 21.19659996032715 58.30251312255859 L 19.9597225189209 40.98620986938477 L 11.61984634399414 40.98620986938477 L 15.47121810913086 58.32067108154297 M 14.26876258850098 59.82448959350586 L 9.750002861022949 39.48620986938477 L 21.35640335083008 39.48620986938477 L 22.80720329284668 59.79740905761719 L 14.26876258850098 59.82448959350586 Z",
    stroke: "none",
    fill: "#0182f0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M18.75,43.236h3.681a2.25,2.25,0,0,1,2.123,2.357v4.956a2.25,2.25,0,0,1-2.123,2.359H20.684",
    transform: "translate(5.43 12.521)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    transform: "translate(12.574 30.282)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.475,
    height: 5.803,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 13.975,
    height: 4.303,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M14.508,0",
    transform: "translate(78.343 33.511)",
    fill: "none",
    stroke: "#0182f0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    "data-name": "Line 62",
    y1: 3.755,
    x2: 14.014,
    transform: "translate(77.256 21.495)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    y1: 10.259,
    x2: 10.259,
    transform: "translate(68.995 0.683)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    x1: 10.259,
    y1: 10.259,
    transform: "translate(68.995 56.08)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    x1: 14.014,
    y1: 3.755,
    transform: "translate(77.255 41.772)",
    fill: "none",
    stroke: "#0182f0",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionIcon);
export default __webpack_public_path__ + "static/media/promotion-icon.0cc464fabea8b42213006eeeb76cdb8b.svg";
export { ForwardRef as ReactComponent };